import { render, staticRenderFns } from "./EmailModel.vue?vue&type=template&id=4ea29406&"
import script from "./EmailModel.vue?vue&type=script&lang=js&"
export * from "./EmailModel.vue?vue&type=script&lang=js&"
import style0 from "./EmailModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports